import React from 'react';
import MinigameCenter from '../../components/Minigame/MinigameCenter';
import SportsRight from '../../components/sports/SportsRight';

const TokenRoulette = () => {
    return (
        <div data-v-623d66c4="" className="contents row" style={{flexDirection: "row"}}>
            <MinigameCenter type="roulette"/>
            <SportsRight type="minigame"/>
        </div>
    );
};

export default TokenRoulette;


// WEBPACK FOOTER //
// ./src/containers/minigame/TokenRoulette.js